import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Landmarks.css";

import mapImage from "../assets/landmarks/map.png";
import sigiriyaImage from "../assets/landmarks/sigiriya_rock.png";
import dambullaTempleImage from "../assets/landmarks/dambulla_temple_image.png";
import jaffnaLibraryImage from "../assets/landmarks/jaffna_public_library.png";
import lotusTowerImage from "../assets/landmarks/lotus_tower.png";
import ellaBridgeImage from "../assets/landmarks/ella_train_bridge_station.jpeg";
import mirissaBeachImage from "../assets/landmarks/mirissa.png";
import pinImage from "../assets/landmarks/pin.png";
import stampImage from "../assets/landmarks/stamp.png";

const landmarkList = [
  {
    id: 1,
    name: "Sigiriya Rock",
    image: sigiriyaImage,
    position: { top: "42%", left: "51%" },
    facts: [
      "Sigiriya is an ancient rock fortress in Sri Lanka.",
      "It is also called Lion Rock.",
      "People climb many steps to reach the top.",
    ],
  },
  {
    id: 2,
    name: "Golden Temple",
    image: dambullaTempleImage,
    position: { top: "53%", left: "48%" },
    facts: [
      "This famous temple is in Dambulla.",
      "The golden statue is about 30 metres tall!",
      "Visitors must remove their shoes before entering!",
    ],
  },
  {
    id: 3,
    name: "Jaffna Library",
    image: jaffnaLibraryImage,
    position: { top: "14%", left: "42%" },
    facts: [
      "This library is in Jaffna, the north of Sri Lanka.",
      "It is one of the most famous libraries in South Asia",
      "It is an important place for learning about the history of Tamil people!",
    ],
  },
  {
    id: 4,
    name: "Lotus Tower",
    image: lotusTowerImage,
    position: { top: "78%", left: "41%" },
    facts: [
      "Lotus Tower is found in the capital, Colombo.",
      "It is 350 meters tall!",
      "It opened to the public in 2022",
    ],
  },
  {
    id: 5,
    name: "Ella Train Station",
    image: ellaBridgeImage,
    position: { top: "75%", left: "53%" },
    facts: [
      "This famous bridge is in a place called Ella.",
      "It is also called the Nine Arches Bridge.",
      "It is one of the most popular places to vist in Sri Lanka.",
    ],
  },
  {
    id: 6,
    name: "Mirissa Beach",
    image: mirissaBeachImage,
    position: { top: "98%", left: "47%" },
    facts: [
      "This beach is one of the most famous in Sri Lanka.",
      "Many people travel here to spot whales.",
      "There are many surf schools in Mirissa",
    ],
  },
];

export default function Landmarks() {
  const goToPage = useNavigate();
  const [selectedLandmark, setSelectedLandmark] = useState(null);

  useEffect(() => {
    // this loads the postcard pictures early so the popup feels smoother
    landmarkList.forEach((landmark) => {
      const preloadImage = new Image();
      preloadImage.src = landmark.image;
    });
  }, []);

  return (
    <div className="landmarksPage">
      <div className="landmarksContent">
        <h1 className="landmarksTitle">Landmarks of Sri Lanka</h1>
        <p className="landmarksSubtitle">
          Click the map pins to explore famous places around Sri Lanka!
        </p>

        <div className="landmarksHeaderTop">
          <button
            className="homeBtn"
            onClick={() => goToPage("/loading", { state: { to: "/home" } })}
            aria-label="Go Home"
            title="Go Home"
            type="button"
          >
            <svg
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="homeBtn__icon"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 0L0 6V8H1V15H4V10H7V15H15V8H16V6L14 4.5V1H11V2.25L8 0ZM9 10H12V13H9V10Z"
                fill="#ffffff"
              />
            </svg>
          </button>
        </div>

        <div className="mapWrapper">
          <img
            src={mapImage}
            alt="Map of Sri Lanka with landmark pins"
            className="mapImage"
          />

          {/* each landmark stores its own map position  */}
          {landmarkList.map((landmark) => (
            <button
              key={landmark.id}
              className="mapPin"
              style={{
                top: landmark.position.top,
                left: landmark.position.left,
              }}
              onClick={() => setSelectedLandmark(landmark)}
              aria-label={`Open postcard for ${landmark.name}`}
            >
              <img src={pinImage} alt="" className="pinImage" />
            </button>
          ))}
        </div>

        {selectedLandmark && (
          <div
            className="postcardOverlay"
            onClick={() => setSelectedLandmark(null)}
          >
            {/* this stops clicks inside the postcard from closing the popup */}
            <div className="postcard" onClick={(event) => event.stopPropagation()}>
              <img
                src={stampImage}
                alt="Postcard stamp"
                className="postcardStamp"
              />

              <div className="postcardImageWrap">
                <img
                  src={selectedLandmark.image}
                  alt={selectedLandmark.name}
                  className="postcardImage"
                />
              </div>

              <div className="postcardText">
                <h2>{selectedLandmark.name}</h2>
                <ul>
                  {selectedLandmark.facts.map((fact) => (
                    <li key={fact}>{fact}</li>
                  ))}
                </ul>

                <button
                  className="continueButton"
                  onClick={() => setSelectedLandmark(null)}
                >
                  Continue Exploring
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}